import React from "react";
import { withRouter } from "react-router-dom";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TextField from "@material-ui/core/TextField";
import Utils from "../utils/utils";
import Snackbar from "@material-ui/core/Snackbar";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
class ClientPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      authState: this.props.authState,
      clients: [],
      campaigns: [],
      selectedclientid: "",
      newCampName: "",
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.authState.state !== this.props.authState.state) {
      this.setState({ authState: this.props.authState });
      this.getCampaign();
      this.getClients();
    }
  }
  doSnackBar(input) {
    this.setState({ statusbar: true, statusbartext: input });
  }

  componentDidMount() {
    setTimeout(() => {
      if (this.state.authState.state !== "signedIn")
        this.props.history.push("/");
      else {
        this.getClients();
        this.getCampaign();
      }
    }, 1000);
  }

  async getCampaign() {
    let camp = await Utils.genericList("listVnaCampaignss", {});
    console.log(camp);
    if (camp) this.setState({ campaigns: camp.data.listVNACampaignss.items });
  }
  async addCampaign(name) {
    let data = {
      name,
      vNACampaignsClientId: this.state.selectedclientid,
    };
    console.log(data)
    await Utils.genericMutation("createVnaCampaigns", data);
    this.doSnackBar("Added camp");
    this.getCampaign();
    // this.setState({ clients });
  }
  async getClients() {
    let clients = await Utils.genericList("listVnaClients", {});
    console.log(clients);
    if (clients) this.setState({ clients: clients.data.listVNAClients.items });
  }
  render() {
    return (
      <div style={{ margin: 20, color: "#666" }}>
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          open={this.state.statusbar}
          autoHideDuration={3000}
          onClose={() => this.setState({ statusbar: false })}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          message={<span id="message-id">{this.state.statusbartext}</span>}
        />
        <h1>campaigns</h1>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <b>campaign name</b>
              </TableCell>
              <TableCell>
                <b>client name</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.campaigns.map((z, idx) => (
              <TableRow key={idx}>
                <TableCell>{z.name}</TableCell>
                <TableCell>{z.client.name}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <h1>Add campaign</h1>
        <TextField
          style={{ marginRight: 10 }}
          value={this.state.newCampName}
          onChange={(change) => {
            this.setState({ newCampName: change.target.value });
          }}
          id="outlined-basic"
          label="camp name"
          variant="outlined"
        />
        <FormControl>
          <InputLabel>client</InputLabel>
          <Select
            id="Add to label"
            style={{ width: 100 }}
            value={this.state.selectedclientid || ""}
            onChange={(change) => {
              // let users = this.state.users;
              // let found = users.filter(
              //   (a) => a.uid === uitem.uid
              // )[0];
              // if (found.selectedClient === null)
              //   found.selectedClient = "";
              // found.selectedClient = change.target.value;
              this.setState({ selectedclientid: change.target.value });
            }}
          >
            {this.state.clients.map((citem, cindex) => (
              <MenuItem key={cindex} value={citem.id}>
                {citem.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            this.addCampaign(this.state.newCampName);
            this.setState({ newClientName: "" });
          }}
        >
          Add new campaign
        </Button>
      </div>
    );
  }
}
export default withRouter(ClientPage);
